import * as stylex from '@stylexjs/stylex'
import { colors } from '../tokens/colors.stylex'

export const pmColors = {
  brand: '#C7A300',
  primary50: '#FDFBF2',
  primary100: '#FBF5D7',
  primary200: '#F5E6A0',
  primary300: '#EAD46E',
  primary400: '#E1C337',
  primary500: '#DAB509',
  primary600: '#C7A300',
  primary700: '#977705',
  primary800: '#7E5F03',
  primary900: '#654901',

  secondary50: '#FAFAFA',
  secondary100: '#F5F5F5',
  secondary200: '#EEEEEE',
  secondary300: '#E1E1E1',
  secondary400: '#BEBEBE',
  secondary500: '#9E9E9E',
  secondary600: '#757575',
  secondary700: '#616161',
  secondary800: '#424242',
  secondary900: '#212121',
}

export const colorTheme = stylex.createTheme(colors, pmColors)
